import React, { useCallback } from "react";
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { useSelector } from "react-redux";
import { useAppThunkDispatch } from "redux/store";
import { updateTask } from "redux/slice/tasks";
import moment from "moment";
import { Task } from "model/task";
import { TaskType } from "type/task-type";
import { dateTimeFormatter } from "shared/date-formatter";
import { TaskStatus } from "type/task-status";
import { styles } from "./style";
import { getLeadsOptimized } from "redux/selector";
import { useHistory } from "react-router-dom";
import * as env from "shared/env";

interface Props extends WithStyles<typeof styles> {
	task: Task;
	onClick: Function;
}

const TaskItemComponent: React.FC<Props> = ({ task, onClick, classes = {} }) => {
	const dispatch = useAppThunkDispatch();
	const history = useHistory();
	const leads = useSelector(getLeadsOptimized);
	
	const { title, type, startOn, endOn, leadId } = task;
	const checked = task.status !== TaskStatus.ACTIVE;
	const checkedStyle = { textDecoration: checked ? "line-through" : "none" };
	const dateText = type === TaskType.APPOINTMENT
		? `Starts ${dateTimeFormatter(startOn)}`
		: `Due ${dateTimeFormatter(endOn)}`;
	const lead = leads && leadId ? leads.find((l: any) => l.id === leadId) : null;
	const leadName = lead ? lead.name : "";

	const toggleCheckBox = useCallback(() => {
		const status = task.status.active ? TaskStatus.COMPLETE : TaskStatus.ACTIVE;
		dispatch(updateTask({ task: { ...task, status } }));
	}, [task, dispatch]);

	const handleLeadClick = useCallback((e: React.MouseEvent) => {
		e.stopPropagation();
		if (leadId) {
			history.push(`/lead/${leadId}`);
		}
	}, [leadId, history]);

	return (
		<div className={classes.container}>
			<div className={classes.titleRow}>
				<Mui.Checkbox
					className={classes.checkbox}
					onChange={toggleCheckBox}
					checked={checked}
				/>
				<div className={classes.noWrapTypographyWrapper}>
					<Mui.Typography
						noWrap
						className={classes.title}
						style={checkedStyle}
						onClick={() => onClick()}
					>
						{title}
						{leadName && (
							<span>
								{' for '}
								<span
									className={classes.leadName}
									onClick={handleLeadClick}
								>
									{leadName}
								</span>
							</span>
						)}
					</Mui.Typography>
				</div>
			</div>
			<Mui.Grid
				container
				direction="row"
				justifyContent="flex-start"
				style={{ paddingTop: 6, paddingLeft: 48 }}
			>
				{type && (
					<Mui.Chip
						icon={<type.icon size={16} />}
						label={type.name}
						size="small"
						className={classes.typeChip}
					/>
				)}
				<Mui.Typography
					style={{ color: endOn > moment() ? "default " : "#f00" }}
					className={classes.date}
				>
					{dateText}
				</Mui.Typography>
			</Mui.Grid>
		</div>
	);
};

export const TaskItem = withStyles(TaskItemComponent, styles);
